module.exports = __webpack_public_path__ + "img/BrowserStack.bf3fe023.png";